module.exports = __webpack_public_path__ + "./fonts/flame-bold.ttf";